import { OverlayType } from '../../constants/common'
import BaseConfig from './overlayBaseConfig'

export type Options = {
  step: number
  maxStep: number
}

export interface Attrs extends Options {
  period: string
  risingColor: string
  fallingColor: string
}

export class SARConfig extends BaseConfig {
  static type = OverlayType.Sar
  static abbreviation = 'sar'
  static label = 'Parabolic SAR'
  static shortLabel = 'SAR'
  static description =
    'Parabolic SAR (Stop and Reverse) is a trend-following indicator that helps identify potential trend reversals and pinpoint entry and exit points. It consists of a series of dots that trail the price, indicating the current trend direction. When the dots are below the price, it suggests an uptrend, and when they are above the price, it signals a downtrend.'

  static optionsOrder = ['step', 'maxStep'] as const
  static optionsLabels = {
    step: 'Step',
    maxStep: 'Maximum Step',
  }

  static inputsOrder = [...this.optionsOrder, 'risingColor', 'fallingColor'] as Array<keyof Omit<Attrs, 'period'>>
  static inputsLabels = { ...this.optionsLabels, risingColor: 'Rising Color', fallingColor: 'Falling Color' }
  static calculatedValuesOrder = ['sar'] as const
  static calculatedValuesLabels = { sar: 'SAR' }
  static defaultCalculatedValueOption = this.calculatedValuesOrder[0]
}
